import { Helmet, HelmetProvider } from "react-helmet-async";
import { AppContext, AppContextProps } from "@/contexts/AppContext";
import { useMemo } from "react";
import { getAppType } from "@/utils/get-app-type";

type MetaTags = {
  title?: string;
  iconDir?: string;
};

function getMetaTags(): MetaTags {
  const appType = getAppType();

  switch (appType) {
    case 'conversion-craft':
      return {
        title: 'ConversionCraft',
        iconDir: 'cc',
      };
    case 'viber-uzenetek':
      return {
        title: 'Viber Üzenetek',
        iconDir: 'vbm',
      };
    default:
      return {};
  }
}

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const appContext: AppContextProps = {
    appType: getAppType(),
  };

  const metaTags = useMemo(() => getMetaTags(), []);

  return ( 
    <AppContext.Provider value={appContext}>
      <HelmetProvider>
        <Helmet>
          <title>{metaTags.title}</title>
          <link rel="apple-touch-icon" sizes="180x180" href={`/${metaTags.iconDir}/apple-touch-icon.png`} />
          <link rel="icon" type="image/png" sizes="32x32" href={`/${metaTags.iconDir}/favicon-32x32.png`} />
          <link rel="icon" type="image/png" sizes="32x32" href={`/${metaTags.iconDir}/favicon-16x16.png`} />
          <link rel="manifest" href={`/${metaTags.iconDir}/site.webmanifest`} />
        </Helmet>
        {children}
      </HelmetProvider>
    </AppContext.Provider>
  );
}